import { ApolloError } from '@apollo/client';

import BaseError from './BaseError';
import BaseUserInputError from './BaseUserInputError';
import ModelValidationError from './ModelValidationError';
import UnknownError from './UnknownError';

function buildApolloError(error: ApolloError) {
  // Using any because the backend has a loose guarantee of what the
  // returned errors are.
  /* eslint-disable @typescript-eslint/no-explicit-any */

  if (error.graphQLErrors.length === 1) {
    const e = error.graphQLErrors[0];
    switch (e.extensions.code) {
      case 'VALIDATION_ERROR':
        return new ModelValidationError(e.extensions.payload as any);
      case 'BAD_USER_INPUT':
        return new BaseUserInputError(e as any);
    }
  }

  console.log('An unhandled Apollo error occurred', error);
  return new UnknownError();
}

export default function buildError(error: unknown): BaseError {
  if (error instanceof ApolloError) {
    // The `error` object has a loose guarantee of type, but there's always
    // space for the Typescript to be incorrect.
    try {
      return buildApolloError(error);
    } catch (e) {}
  }
  console.log('An unhandled error occurred', error);
  return new UnknownError();
}
